import React from 'react';
import {Link} from "react-router";

import melek from "../assets/melek.png";
import zeki from "../assets/zeki.png";
import ceren from "../assets/ceren.png";
import onur from "../assets/onur.png";
import aziz from "../assets/aziz.png";


function Hakkimizda(props) {
    return (
        <React.Fragment>
            <div className="breadcumb bg-overlay-one">
                <div className="breadcumb__bottom-thumb">
                    <img src="assets/images/thumb/banner-bid.png" alt=""/>
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="breadcumb__wrapper">
          <span className="breadcumb__title">
            hakkımızda
          </span>
                                <ul className="breadcumb__list">
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            {" "}
                                            <i className="las la-home"/> Ana Sayfa
                                        </Link>{" "}
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">HAKKIMIZDA</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="about-us py-120">
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-md-7 pe-lg-5">
                            <div className="about-left">
                                <div className="about-left__thumbs">
                                    <img src="assets/images/thumb/about-img-01.png" alt=""/>
                                    <img src="assets/images/thumb/about-img-02.png" alt=""/>
                                </div>
                                <div className="about-24">
                                    <span className="about-24__text">24+</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="about-content">
                                <div className="section-heading style-two">

                                    <h2 className="section-heading__title">
                                        <span className="section-heading__title-colored"> Audiotime</span>{" "}
                                    </h2>
                                    <p className="section-heading__desc">

                                        Audiotime, Türkiye’nin önde gelen ses yayıncılarına reklam vermenizi sağlayan
                                        bir dijital audio ve karasal radyo reklam satış evidir. Türkiye’de dijital
                                        audio reklam pazarının oluşturulmasında öncü olmuş, karasal radyo pazarına
                                        hakim profesyonel bir kadroya sahip olan Audiotime, sektörde sınanmış
                                        tecrübesine ek olarak yeni nesil teknolojiler ile radyo ve ses reklamcılığının
                                        en inovatif projelerine imza atmayı hedeflemektedir.
                                    </p>
                                </div>
                                {/*<div className="about-info">*/}
                                {/*    <div className="about-info__thumb">*/}
                                {/*        <img src="assets/images/thumb/about-img.png" alt="" />*/}
                                {/*    </div>*/}
                                {/*    <div className="about-info__details">*/}
                                {/*        <h5 className="about-info__name">Transport Signal</h5>*/}
                                {/*        <span className="about-info__designation">CEo,Fmlab</span>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section
                className="team-and-counter py-120 bg-img"
                style={{backgroundImage: "url(./assets/images/thumb/team-bg.png)", backgroundColor: "#0a0a0a"}}
            >
                <div className="team-bottom-thumb">
                    <img src="assets/images/thumb/footer-bid.png" alt=""/>
                </div>
                {/* Team Start */}
                <div className="team-wrapper">
                    <div className="container">
                        <div className="row ">
                            <div className="col-lg-12">
                                <div className="section-heading style-two">
                                    <h5 className="section-heading__subtitle" style={{color: "#fff"}}>
                                        <span className="section-heading__bars bars-one"/> EKİP{" "}
                                        <span className="section-heading__bars bars-two"/>
                                    </h5>
                                    <h2 className="section-heading__title" style={{color: "white"}}>
                                        {" "}
                                        <span className="section-heading__title-colored">
                 AUDIOTIME
                </span>{" "} AİLESİ
                                    </h2>

                                </div>
                            </div>
                        </div>
                        <div
                            className="row team-item-wrapper dots-right-top margin-in-slider justify-content-center gy-4">
                            <div className="team-item">
                                <div className="team-item__thumb">
                                    <img src={melek} alt=""/>
                                    <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Melek Doyan Etik
                                        </span>{" "}
                                        <span className="team-item__title-colored">Managing Partner</span>{" "}
                                    </h4>
                                </div>
                            </div>
                            <div className="team-item">
                                <div className="team-item__thumb">
                                    <img src={zeki} alt=""/>
                                    <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Zeki Gültekin
                                        </span>{" "}
                                        <span className="team-item__title-colored">Managing Partner</span>{" "}
                                    </h4>
                                </div>
                            </div>
                            <div className="team-item">
                                <div className="team-item__thumb">
                                    <img src={ceren} alt=""/>
                                    <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Ceren Dinlergüler
                                        </span>{" "}
                                        <span className="team-item__title-colored">Advertising Sales Manager</span>{" "}
                                    </h4>
                                </div>
                            </div>
                            <div className="team-item">
                                <div className="team-item__thumb">
                                    <img src={onur} alt=""/>
                                    <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Onur Kavran
                                        </span>{" "}
                                        <span className="team-item__title-colored">Reservation Manager</span>{" "}
                                    </h4>
                                </div>
                            </div>
                            <div className="team-item">
                            <div className="team-item__thumb">
                                <img src={aziz} alt=""/>
                                <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Aziz Şişman
                                        </span>{" "}
                                    <span className="team-item__title-colored">Operations Specialist</span>{" "}
                                </h4>
                            </div>
                        </div>
                            {/*<div className="team-item">*/}
                            {/*    <div className="team-item__thumb">*/}
                            {/*        <img src="assets/images/thumb/team-img-02.png" alt="" />*/}
                            {/*        <div className="team-item__socails">*/}
                            {/*            <ul className="social-list">*/}
                            {/*                <li className="social-list__item">*/}
                            {/*                    <a*/}
                            {/*                        href="https://www.facebook.com"*/}
                            {/*                        className="social-list__link"*/}
                            {/*                    >*/}
                            {/*                        <span className="icon-facebook" />*/}
                            {/*                    </a>{" "}*/}
                            {/*                </li>*/}
                            {/*                <li className="social-list__item">*/}
                            {/*                    <a*/}
                            {/*                        href="https://www.twitter.com"*/}
                            {/*                        className="social-list__link active"*/}
                            {/*                    >*/}
                            {/*                        {" "}*/}
                            {/*                        <span className="icon-twitter" />*/}
                            {/*                    </a>*/}
                            {/*                </li>*/}
                            {/*                <li className="social-list__item">*/}
                            {/*                    <a*/}
                            {/*                        href="https://www.linkedin.com"*/}
                            {/*                        className="social-list__link"*/}
                            {/*                    >*/}
                            {/*                        {" "}*/}
                            {/*                        <span className="icon-linkedin" />*/}
                            {/*                    </a>*/}
                            {/*                </li>*/}
                            {/*                <li className="social-list__item">*/}
                            {/*                    <a*/}
                            {/*                        href="https://www.pinterest.com"*/}
                            {/*                        className="social-list__link"*/}
                            {/*                    >*/}
                            {/*                        {" "}*/}
                            {/*                        <span className="icon-pinterest" />*/}
                            {/*                    </a>*/}
                            {/*                </li>*/}
                            {/*            </ul>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}


                        </div>
                    </div>
                </div>
                {/* team End */}
            </section>

        </React.Fragment>
    );
}

export default Hakkimizda;